import { Button, Grid } from '@mui/material';
import { Field } from 'formik';
import * as React from 'react';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';

import { useWebhookHistoryContext } from './context';

export const FilterWebhookHistory = () => {
  const { type, productId } = useWebhookHistoryContext();
  const isInvoice = type === 'invoice';
  const isSubscription = type === 'contract';
  const isAbandonment = type === 'abandonment';
  const mdByType = isAbandonment ? 4 : 3;
  const disableSelectProduct = productId !== -1;

  return (
    <Grid container spacing={2} justifyContent='flex-end' alignItems='flex-end'>
      <Grid xs={12} item md={3}>
        <Field placeholder='Data de envio' label='Data de envio' id='date' name='date' fullWidth component={DateRangePickerFormField} />
      </Grid>

      {!disableSelectProduct && (
        <Grid item xs={12} md={mdByType}>
          <Field
            id='webhook-historic-product'
            name='product_id'
            hasLabel
            fullWidth
            component={SelectProduct}
            endpoint='reports/filter-all-products'
          />
        </Grid>
      )}

      <Grid item xs={12} md={disableSelectProduct && isAbandonment ? 8 : disableSelectProduct ? 6 : mdByType}>
        <Field
          id='webhook-historic-customer'
          name='customer'
          label='Comprador'
          placeholder='Pesquisar por nome ou email'
          fullWidth
          component={TextFormField}
        />
      </Grid>

      {isInvoice && (
        <Grid item xs={12} md={2}>
          <Field id='entityId' name='entityId' component={TextFormField} fullWidth label={'Fatura'} type={'tel'} placeholder='Pesquisar por fatura' />
        </Grid>
      )}

      {isSubscription && (
        <Grid item xs={12} md={2}>
          <Field
            id='entityId'
            name='entityId'
            component={TextFormField}
            fullWidth
            label={'Contrato'}
            type={'tel'}
            placeholder='Pesquisar por contrato'
          />
        </Grid>
      )}

      <Grid item xs={12} md={1}>
        <Button variant='contained' color='primary' fullWidth type='submit'>
          Filtrar
        </Button>
      </Grid>
    </Grid>
  );
};
